<template>
  <v-dialog v-model="dialog" width="500px">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="kt-header__topbar-item kt-header__topbar-item--search dropdown"
        id="kt_quick_search_toggle"
      >
        <div class="kt-header__topbar-wrapper">
          <span class="kt-header__topbar-icon">
            <span class="pulsing">UPLOAD</span>
          </span>
        </div>
      </div>
    </template>
    <v-card>
      <v-card-text class="p-0"> </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddUnitDialog',
};
</script>

<style lang="stylus" scoped>
.pulsing, .pulsing-active {
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  animation: pulse-black 1.2s infinite;
}
/* Animation */
@keyframes pulse-black {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0 0);
  }
}
</style>
